import { CssBaseline, GlobalStyles } from "@mui/material";

const GlobalStyle = () => (
  <>
    <CssBaseline />
    <GlobalStyles
      styles={{
        body: {
          margin: 0,
          padding: 0,
          fontFamily: "'Raleway', sans-serif",
          backgroundColor: "#f5f5f5",
          color: "#333333",
          paddingBottom: "45px",
        },
        a: {
          color: "#00bcd4",
          textDecoration: "none",
        },
        button: {
          borderRadius: "5px",
          transition: "background-color 0.3s",
        },
      }}
    />
  </>
);

export default GlobalStyle;
